// @flow

const userAgent: string = window.navigator.userAgent

export function isInWeixin (): boolean {
  return /MicroMessenger/i.test(userAgent)
}

export function isInAndroidFjApp (): boolean {
  return /FengjrAppAndroid/i.test(userAgent)
}

export function isInIOSFjApp (): boolean {
  return /FengjrAppIOS/i.test(userAgent)
}

export function isInAndroidZxApp (): boolean {
  return /FengzxAppAndroid/i.test(userAgent)
}

export function isInIOSZxApp (): boolean {
  return /FengzxAppIOS/i.test(userAgent)
}

export function isInFjApp (): boolean {
  return /FengjrApp/i.test(userAgent)
}

export function isInWeixinApp (): boolean {
  return /miniprogram/i.test(userAgent)
}

export function isInAndroidLcsApp (): boolean {
  return /FengLcsAppAndroid/i.test(userAgent)
}

export function isInIOSLcsApp (): boolean {
  return /FengLcsAppIOS/i.test(userAgent)
}

export function isInLcsApp (): boolean {
  return /FengLcsApp/i.test(userAgent)
}

export function isInApp (): boolean {
  return (
    isInFjApp() ||
    isInYddApp() ||
    isInZxApp() ||
    isInXqkdApp() ||
    isInLcsApp() ||
    isInWeixinApp()
  )
}

export function isInZxApp (): boolean {
  return /FengzxApp/i.test(userAgent)
}

export function isInYddApp (): boolean {
  return /FengphApp/i.test(userAgent)
}

export function isInAndroid (): boolean {
  return /android/i.test(userAgent)
}

export function isInIOS (): boolean {
  return /iPhone/i.test(userAgent)
}

export function isInXqkdApp (): boolean {
  return /FengxqkdApp/i.test(userAgent)
}

export function isInIOSXqkdApp (): boolean {
  return /FengxqkdAppIOS/i.test(userAgent)
}

export function isInAndroidXqkdApp (): boolean {
  return /FengxqkdAppAndroid/i.test(userAgent)
}

export function isInAndroidApp () {
  return (
    isInAndroidFjApp() ||
    isInAndroidZxApp() ||
    isInAndroidXqkdApp() ||
    isInAndroidLcsApp()
  )
}

export function isInIOSApp () {
  return (
    isInIOSFjApp() || isInIOSZxApp() || isInIOSXqkdApp() || isInIOSLcsApp()
  )
}
export function getAppVersion (): string {
  let result = /(?:FengjrApp|FengphApp|FengxqkdApp)(?:IOS|Android)\/(\d+[.]\d+([.]\d+)?)/.exec(
    userAgent
  )
  if (result) {
    return result[1]
  } else {
    return '0.0.0'
  }
}

export { userAgent }



// WEBPACK FOOTER //
// ./src/frame/core/browserEnv.js